import React, { } from 'react';
import {
  Collapse,
} from 'antd';
import CheckedIcon from 'Components/alerts/assets/svg/CheckedIcon';
import CrossCircle from 'Components/common/assets/svgIcons/CrossCircle';
import { useDispatch, useSelector } from 'react-redux';
import { selectActiveTask, selectShowAccordion } from 'Selector/CertificationSelector';
import { certificationBot } from '../../../Utils/utilsStyle';
import { CustomCaretDownOutlined } from './CustomizedPanel';
import { actions } from '../../../Slice/CertificationSlice';

const BottomAccordion = function BottomAccordion() {
  const { Panel } = Collapse;
  const task = useSelector(selectActiveTask);
  const show = useSelector(selectShowAccordion);
  const dispatch = useDispatch();

  const closeAccordion = () => {
    dispatch(actions.resetActiveTask());
    dispatch(actions.resetCurrentType());
    dispatch(actions.setShowAccordion(false));
  };

  return (
    <div className="d-flex justify-content-center">
      {
        show ? (
          <Collapse
            className="certification-collapse-bottom"
            expandIcon={({ isActive }) => CustomCaretDownOutlined({ isActive })}
            ghost
            accordion
          >
            <span
              tabIndex={0}
              role="button"
              onClick={() => closeAccordion()}
              onKeyPress={() => closeAccordion()}
              className="cross-circle-accordion"
            >
              <CrossCircle />
            </span>
            <Panel
              header={(
                <span className="accordion-header">
                  <div>
                    <img
                      className="header-image"
                      alt="gilroy"
                      src={certificationBot}
                    />
                    {task?.header}
                  </div>

                </span>
              )}
              key="1"
            >
              <div className="sub-component-div">
                {task?.events?.map((event) => (
                  <span className="panel-sub-component">
                    <span>
                      {event.title}
                    </span>
                    {event.status === 1 ? <CheckedIcon /> : null}
                  </span>
                ))}
              </div>
            </Panel>
          </Collapse>
        ) : null
      }
    </div>
  );
};
export default BottomAccordion;
